import { mutationOptions, queryOptions } from "@tanstack/react-query";
import {
  parseResponse,
  type InferRequestType,
  type InferResponseType,
} from "hono/client";

import { client } from "~/lib/api";

export type Partner = InferResponseType<typeof client.portal.me.$get, 200>;
type SettingsRequest = InferRequestType<typeof client.portal.me.$patch>["json"];

export const meQueryKey = ["portal", "me"] as const;

export function isParent(partner: Pick<Partner, "parentId">): boolean {
  return partner.parentId === undefined;
}

export const meQueryOptions = () =>
  queryOptions({
    queryKey: meQueryKey,
    meta: { handlesUnauthorized: true },
    queryFn: () => parseResponse(client.portal.me.$get()),
  });

export const updateSettingsMutationOptions = () =>
  mutationOptions({
    mutationFn: (json: SettingsRequest) =>
      parseResponse(client.portal.me.$patch({ json })),
    onSuccess: (partner, _json, _result, context) => {
      context.client.setQueryData(meQueryKey, partner);
    },
  });
